module.exports = __webpack_public_path__ + "img/ju.4111b745.png";